import { FormEditorSaveEventPayload, FormEditorViewModel } from "@Alternatives/Forms/Components/FormEditor";
import FormEditor from "@Alternatives/Forms/Components/FormEditor.vue";
import { CreateFormCommandV1 } from '@Alternatives/Forms/Domain/commands-core';
import FormsCommands from "@Alternatives/Forms/Domain/commands-vue-component";
import FormsQueries from '@Alternatives/Forms/Domain/queries-vue-component';
import { FormReadModel } from '@Alternatives/Forms/Domain/readmodels';
import { Refresh } from '@browser/Browser';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { ICommandStatus } from '@cqrs/cqrs';
import { ICommandBase } from '@Pages/cqrs';
import { UpdateRequestPageCommandV1 } from '@Pages/Domain/commands-core';
import PagesCommands from '@Pages/Domain/commands-vue-component';
import PagesQueries from '@Pages/Domain/queries-vue-component';
import { RequestPageEditorPageReadModel } from '@Pages/Domain/readmodels';
import { Editor } from "@progress/kendo-vue-editor";
import { Component, mixins } from 'vue-facing-decorator';
import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

@Component({
    components: {
        PortfolioOrDecisionNavigation, Editor, FormEditor
    }
})
export default class RequestPageEditorPage extends mixins(PagesQueries, PagesCommands, FormsQueries, FormsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId); }
    get pageId(): number { return Number.parseInt(this.$route.params.pageId); }

    get url_RequestPagesPage()
    {
        return dynamicUiRoutes.Pages_RequestPagesPage(this.$route, this.workspaceId, this.projectId);
    }

    url_EditFormPage(formId: number)
    {
        return dynamicUiRoutes.Alternatives_EditFormPage(this.$route, this.workspaceId, this.projectId, formId);
    }

    rm: RequestPageEditorPageReadModel | null = null;

    formEditor: FormEditorViewModel = new FormEditorViewModel();

    content: string | null = null;

    tools = [
        ["Bold", "Italic", "Underline", "Strikethrough"],
        ["Subscript", "Superscript"],
        ["AlignLeft", "AlignCenter", "AlignRight", "AlignJustify"],
        ["Indent", "Outdent"],
        ["OrderedList", "UnorderedList"],
        "FontSize",
        "FontName",
        "FormatBlock",
        ["Undo", "Redo"],
        ["Link", "Unlink", "InsertImage", "ViewHtml"],
        ["InsertTable"],
        ["AddRowBefore", "AddRowAfter", "AddColumnBefore", "AddColumnAfter"],
        ["DeleteRow", "DeleteColumn", "DeleteTable"],
        ["MergeCells", "SplitCell"],
    ];




    showFormCreator()
    {
        this.formEditor.showCreator();
    }

    handleCreateFormCommand(e: FormEditorSaveEventPayload)
    {
        this.invokeCreateFormCommandV1(this.workspaceId, this.projectId, 0, e.name, null);
    }
    

    handleUpdateRequestPageCommand()
    {
        if (!this.rm.Name || this.rm.Name.length < 2)
        {
            alert("Name is required. At least 2 characters.");
            return;
        }

        const html = (this.$refs.editor as any).getHTML();
        this.invokeUpdateRequestPageCommandV1(this.workspaceId, this.projectId, this.pageId, this.rm.Name, this.rm.Description, this.rm.LogoUrl, html, this.rm.FormId);
    }

    mounted()
    {
        document.title = "Request page | TransparentChoice";
        this.runRequestPageEditorPageQueryV1(this.workspaceId, this.projectId, this.pageId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "RequestPageEditorPageReadModel")
        {
            this.rm = model as RequestPageEditorPageReadModel;
        }
        else if (modelName == "FormReadModel")
        {
            const f = model as FormReadModel;
            this.rm.Forms.push(f);
            this.rm.FormId = f.Id;

            this.formEditor.close();
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (UpdateRequestPageCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (CreateFormCommandV1.matchType(cmd))
        {
            this.runFormByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, Number(result));
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (UpdateRequestPageCommandV1.matchType(status.Command))
        {
            for (const error of status.ValidationErrors)
            {
                alert(error.Error);
            }
        }
        else if (CreateFormCommandV1.matchType(status.Command))
        {
            this.formEditor.displayValidationErrors(status.ValidationErrors);
        }
    }
}